<template>
  <div class="xh-wrap">
    <div class="container text-center">
      <img
        class="logo md-hidden"
        src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/media_logo_pc.png"
      />
      <img
        class="logo  lg-hidden md-visible"
        src="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/media_logo_mb.png"
      />
      <img
        class="mt-190 qrcode"
        :src="_i18n.locale=='en'?'https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/media_qr_en.png':'https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/page_media.jpeg'"
      />
      <!-- <div class="color-fff fs-20 mt-20">关注“广州车展媒体之窗”微信公众号,</div> -->
      <div class="color-fff fs-20 mt-20">
        {{ $t('mediacenter.applytips1') }}
      </div>
      <div class="passport_other" @click="tomedia">
        <span>{{ $t('mediacenter.applytips2') }}</span>
        <!-- <span>Reporters from other countries and areas please click here</span> -->
      </div>
      <footer class="fs-20 color-fff">
        {{ $t('pagebottom.copyright') }}
        <a
          class="color-fff"
          target="_blank"
          href="http://www.beian.miit.gov.cn/"
          >粤ICP备17092841号-4</a
        >
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    console.log(this._i18n.locale);
  },
  methods: {
    tomedia(){
      // this.$router.push({path:'/foreignMediaMain'})
      window.location.href = 'https://vrhall.ccnfgame.com/wapp/chat/#/pages/mediaguangzhou/foreignMediaMain'
    }
  },
};
</script>

<style scoped lang="scss">
img {
  display: block;
  margin: 0 auto;
}
footer {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  line-height: 60px;
  width: 100%;
  background-color: #419ffc;
}
@media screen and (min-width: 100px) and (max-width: 1000px) {
  footer {
    height: 180px;
    line-height: 180px;
  }
  .xh-wrap {
    padding-top: 400px;
  }
  .md-hidden {
    display: none;
  }
  .md-visible {
    display: block;
  }
  .mt-190 {
    margin-top: 300px;
  }
  .logo {
    width: 70%;
  }
  .qrcode {
    width: 70%;
    margin-bottom: 120px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .lg-hidden {
    display: none;
  }
  .xh-wrap {
    padding-top: 100px;
  }
  .mt-190 {
    margin-top: 100px;
  }
  .logo {
    width: 731px;
  }
  .qrcode {
    width: 360px;
  }
  .passport_other{
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: #fff;
    cursor: pointer;
    >span{
      font-size: 20px;
      
    }

  }
  .passport_other:hover{
    color: #419ffc;
  }
}
</style>



// WEBPACK FOOTER //
// mediaApply.vue?2d0d9118